import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { useUpdateStatusMutation } from 'api/api';
import FigmaModal from 'components/modal/FigmaModal';
import { isOtherFirmAdmins } from 'components/tables/UserTable';

const UserSwitch = ({ rowData, userRole, users }) => {
  const [updateStatus, { isLoading }] = useUpdateStatusMutation();
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleChange = async (event) => {
    const newEnabledState = event.target.checked;
    if (isOtherFirmAdmins(rowData.auth0_id, users) || newEnabledState) {
      try {
        await updateStatus({ auth0_id: rowData.auth0_id, is_enabled: newEnabledState });
      } catch (error) {
        console.error("Failed to update user status:", error);
      }
    } else {
      setIsModalOpen(true);
    }
  };

  return (
    <>
      <FigmaModal open={isModalOpen} onClose={() => setIsModalOpen(false)} type={'finalFirmAdminWarning'} />
      <FormControlLabel
        style={{ minWidth: '120px' }}
        control={
          <Switch
            checked={rowData.is_enabled}
            onChange={handleChange}
            disabled={!['Super Admin', 'Sub Super Admin', 'Firm Admin'].includes(userRole ?? '') || isLoading}
          />
        }
        label={rowData.is_enabled ? 'Active' : 'Inactive'}
      />
    </>
  );
};

export default UserSwitch;